import { S_TYPE } from './fetchMatchingDrugsLabTests';
import { TREATMENT_PLAN_TYPE } from './getTreatmentPlans';

export const isForProd = process.env.REACT_APP_FOR === 'prod';
export const isForBeta = process.env.REACT_APP_IS_BETA === 'true';

const prod = {
    mdb: 'https://mdb.eka.care',
    auth: 'https://auth.eka.care',
    authgo: isForBeta ? 'https://aortago-pp.eka.care' : 'https://aortago.eka.care',
    parchi: isForBeta ? 'https://beta-parchi.eka.care' : 'https://parchi.eka.care',
    trinity: isForBeta ? 'https://aortago-pp.eka.care' : 'https://trinity.eka.care',
    tryst: 'https://tryst.eka.care',
    appointments_calendar: 'https://eka.care',
    sync: 'https://sync.eka.care',
    tele: 'https://tele.eka.care',
    files: 'https://vault.eka.care',
    payments: 'https://payment.eka.care',
    stetho: isForBeta ? 'https://beta-dr.eka.care' : 'https://dr.eka.care',
    analytics: 'https://fhir-serve.eka.care',
    elixir: 'https://elixir-mweb.eka.care',
    agoraAppId: 'f1c7a40e1d4349888ff1b69714a3436c',
    pxStore: 'https://m-prod-prescription-store.s3.ap-south-1.amazonaws.com',
    mixpanelToken: 'cc77075637f0038adc65bebbefc2d8e4',
    perceptToken: '1a9df99408cf56da1ccc50f5c9faade40e2eabbabbd210dea501e338d4196fff',
    ga: 'G-K1Y66NK7P1',
    sentry: 'https://18f0cbbbdbc74d5286764ff7806da213@o1128948.ingest.sentry.io/6172272',
    appziUrl: 'https://w.appzi.io/w.js?token=NXu8j',
    pocket: 'https://pocket.eka.care',
    ndhm: 'https://ndhm.eka.care',
    patient_profile_cloudfront: 'https://a.eka.care',
    abha: 'https://eka.care',
    abhaJs: 'https://elixir-dr.eka.care/abha-build-2/app-index.js',
    abhaCss: 'https://elixir-dr.eka.care/abha-build-2/app-index.css',
    khata: 'https://khata.eka.care',
    littmann: 'https://mdr.eka.care',
    dr_analytics: 'https://dr-analytics.eka.care',
    axon: 'https://axon.eka.care',
    fingertip: 'https://mweb.eka.care',
    orbit: 'https://orbit.eka.care/dr-web/dr.purged.css?t=v20',
    lucid: 'https://lucid.eka.care',
    lucidWs: 'https://lucid-ws.eka.care',
    metropolisTeleHost: 'https://consultation.metropolisindia.com',
    hub: 'https://hub.eka.care',
    revive: 'https://revive.eka.care',
    runPrompt: 'https://lucid.eka.care',
    firebaseConfig: {
        apiKey: 'AIzaSyDysT_6COV-ViUjjocLq345LS3s7r0mqzY',
        authDomain: 'eka-care.firebaseapp.com',
        databaseURL: 'https://eka-care-default-rtdb.asia-southeast1.firebasedatabase.app',
        projectId: 'eka-care',
        storageBucket: 'eka-care.appspot.com',
        messagingSenderId: '973687342109',
        appId: '1:973687342109:web:9dee17e0c94bd450c5f2f4',
        measurementId: 'G-J2FGWMJC4Q',
    },
    firestoreAptDbName: 'doctool',
    login: 'https://login.eka.care',
    rxPdfHost: 'https://prescription-store-s3.eka.care',
    teleBE: 'https://resono.eka.care',
    cog: 'https://cog.eka.care',
};

const staging = {
    mdb: 'https://mdb.dev.eka.care',
    auth: 'https://aorta.dev.eka.care',
    authgo: 'https://aortago.dev.eka.care',
    parchi: 'https://parchi.dev.eka.care',
    trinity: 'https://trinity.dev.eka.care',
    tryst: 'https://tryst.dev.eka.care',
    appointments_calendar: 'https://curio.dev.eka.care',
    sync: 'https://sync.dev.eka.care',
    tele: 'https://agota.dev.eka.care',
    files: 'https://vault.dev.eka.care',
    payments: 'https://payment.dev.eka.care',
    stetho: 'https://docapp.dev.eka.care',
    analytics: 'https://fhir-serve.eka.care',
    elixir: 'https://elixir-mweb.dev.eka.care',
    agoraAppId: 'a778e249134e4cd1b6560fcda3f290e4',
    pxStore: 'https://prescription-store.s3.ap-south-1.amazonaws.com',
    mixpanelToken: '301023b0a63d2fa20a516329bac66fc5',
    perceptToken: '651737d8ba9b9b23a89a7c971a3f01c4ca0a1cc7f45a11643bdcb0a9373835e6',
    ga: '',
    sentry: '',
    appziUrl: '',
    pocket: 'https://pocket.dev.eka.care',
    ndhm: 'https://ndhm.dev.eka.care',
    patient_profile_cloudfront: 'https://eka-avatar.dev.eka.care',
    abha: 'https://curio-abdm.dev.eka.care',
    abhaJs: 'https://doc-abha.dev.eka.care/build/app-index.js',
    abhaCss: 'https://doc-abha.dev.eka.care/build/app-index.css',
    khata: 'https://khata.dev.eka.care',
    littmann: 'https://littmann.dev.eka.care',
    dr_analytics: 'https://dr-analytics.dev.eka.care',
    axon: 'https://axon.eka.care',
    fingertip: 'https://fingertip.dev.eka.care',
    orbit: 'https://orbit.dev.eka.care/dr-web/dr.purged.css?t=v20',
    lucid: 'https://lucid.dev.eka.care',
    lucidWs: 'https://lucid-ws.dev.eka.care',
    metropolisTeleHost: 'https://consultation.metropolisindia.com',
    hub: 'https://hub.dev.eka.care',
    revive: 'https://revive.dev.eka.care',
    runPrompt: 'https://lucidWs.dev.eka.care',
    firebaseConfig: {
        apiKey: 'AIzaSyBqQevu_E2aS9oiUD0Eb0sil-W2Galmrrc',
        authDomain: 'eka-care-preprod.firebaseapp.com',
        databaseURL: 'https://eka-care-preprod-default-rtdb.firebaseio.com',
        projectId: 'eka-care-preprod',
        storageBucket: 'eka-care-preprod.firebasestorage.app',
        messagingSenderId: '930380983640',
        appId: '1:930380983640:web:06a5aef85be8753c99892d',
        measurementId: 'G-WB3NJ77PPM',
    },
    firestoreAptDbName: 'doctool',
    login: 'https://aortago.dev.eka.care',
    rxPdfHost: 'https://prescription-store-s3.dev.eka.care',
    teleBE: 'https://resono.dev.eka.care',
    cog: 'https://cog.dev.eka.care',
};

function buildQueryParams(params: { [k: string]: string | undefined | null }) {
    const p = new URLSearchParams();
    Object.keys(params)
        .filter(
            (key) =>
                key?.length && params[key] && params[key] !== undefined && params[key] !== null,
        )
        // TS isn't smart enough to know that the value is not undefined/null
        .forEach((key) => p.append(key, params[key]?.toString() as string));

    return p.toString();
}

const env = isForProd ? prod : staging;

export const APPZI_URL = env.appziUrl;

export const BOOKING_SLUG = env.appointments_calendar;
export const ABHA = env.abha;
export const TELE_BE_V2 = env.teleBE;

export const ELIXIR_URL = env.elixir;

export const ABHA_MODULE_JS = env.abhaJs;
export const ABHA_MODULE_CSS = env.abhaCss;
export const AXON_URL = env.axon;

export const MEDICAL_DB_BASE_URL = env.mdb;
export const AUTH_BASE_URL = env.auth;
export const AUTHGO_BASE_URL = env.authgo;
export const DOCS_APP_BE_URL = env.parchi;
export const TRINITY_BE_URL = env.trinity;
export const APPOINTMENTS_BE_URL = env.tryst;
export const SYNC_BE_URL = env.sync;
export const TELE_BE_URL = env.tele;
export const MEDICAL_RECORDS_BE_URL = env.files;
export const AGORA_APP_ID = env.agoraAppId;
export const PAYMENTS = env.payments;
export const MIXPANEL_TOKEN = env.mixpanelToken;
export const PERCEPT_TOKEN = env.perceptToken;
export const GA_TOKEN = env.ga;
export const SENTRY_DNS = env.sentry;
export const DOC_TOOL = env.stetho;
export const ANALYTICS = env.analytics;
export const POCKET_URL = env.pocket;
export const NDHM_URL = env.ndhm;
export const PATIENT_PROFILE_CLOUDFRONT = env.patient_profile_cloudfront;
export const KHATA = env.khata;
export const LITTMANN = env.littmann;
export const DR_ANALYTICS = env.dr_analytics;
export const FINGERTIP = env.fingertip;
export const ORBIT = env.orbit;
export const LUCID = env.lucid;
export const LUCID_WS = env.lucidWs;
export const RUN_PROMPT = env.runPrompt;
export const METROPOLIS_TELE_HOST = env.metropolisTeleHost;
export const HUB = env.hub;
export const REVIVE = env.revive;
export const FIREBASE_CONFIG = env.firebaseConfig;
export const FIRESTORE_APT_DB_NAME = env.firestoreAptDbName;
export const LOGIN = env.login;
export const RX_PDF_HOST = env.rxPdfHost;
export const COG = env.cog;

export const CREATE_MEDICINES_CART = (docid: string) => `${POCKET_URL}/app/cart/create/${docid}`;
export const ORDER_MEDICINES_CART = (docid: string) => `${POCKET_URL}/app/order/create/${docid}`;
export const UPDATE_MEDICINES_CART = (docid: string) => `${POCKET_URL}/app/cart/update/${docid}`;
export const GET_MEDICINES_ORDER = (pxId: string, orderId: string): string =>
    `${POCKET_URL}/app/order/get?pxid=${pxId}&order_id=${orderId}`;
export const GET_ATTACHMENT_TEMPLATES = `${DOCS_APP_BE_URL}/post/get/attachment-templates-for-doc-id/all`;
export const GET_POSTS_BY_PATIENT_ID = (patientId: string): string =>
    `${DOCS_APP_BE_URL}/post/get/posts-by-patient-id/all?patientId=${patientId}`;

export const DELETE_ATTACHMENT_TEMPLATES = `${DOCS_APP_BE_URL}/post/delete/attachment-templates-by-id`;

export const GET_ALL_MEDICINES_ORDER = (docIds: string) =>
    `${DOCS_APP_BE_URL}/service/order-medicines/get/transactions${
        docIds ? `?docids=${docIds}` : ''
    }`;
export const GET_ALL_LABS_ORDER = (docIds: string) =>
    `${DOCS_APP_BE_URL}/service/book-lab-tests/get/transactions${
        docIds ? `?docids=${docIds}` : ''
    }`;
export const GET_ACCESS_GROUPS = `${DOCS_APP_BE_URL}/service/account/configuration`;

export const CANCEL_MEDICINES_ORDER = (docid: string) => `${POCKET_URL}/app/cancel-order/${docid}`;
export const CANCEL_LAB_TEST_BOOKING = (docid: string) =>
    `${POCKET_URL}/lab/cancel-booking/${docid}`;

export const CREATE_LAB_TEST_CART = (docid: string) => `${POCKET_URL}/lab/cart/create/${docid}`;
export const ORDER_LAB_TEST_CART = (docid: string) => `${POCKET_URL}/lab/order/create/${docid}`;
export const GET_LAB_TEST_SLOT = (docid: string) => `${POCKET_URL}/lab/slot/get/${docid}`;
export const GET_LAB_TEST_ORDER = (pxId: string, orderId: string): string =>
    `${POCKET_URL}/lab/order/get?pxid=${pxId}&order_id=${orderId}`;
export const GET_PACKAGE_PANEL_DETAILS = (docid: string, eka_id: string): string =>
    `${POCKET_URL}/lab/get-package-panel-details/${docid}?eka_id=${eka_id}`;

export const GET_DOCTOR_PACKAGES = (docid: string) =>
    `${POCKET_URL}/lab/get-doctor-packages/${docid}`;

export const GET_PATIENT_ADDRESS = (docid: string, patient_oid: string): string =>
    `${DOCS_APP_BE_URL}/service/address/get/${docid}?pid=${patient_oid}`;

export const SET_PATIENT_ADDRESS = (docid: string): string =>
    `${DOCS_APP_BE_URL}/service/address/set/${docid}`;

export const GET_CURRENT_TIME = `${DOC_TOOL}/server/gettime`;
export const ON_REGISTER_ABDM = `${DOCS_APP_BE_URL}/service/abdm/lead`;

export const GET_MATCHING_SYSPTOMS = (text: string): string =>
    `${MEDICAL_DB_BASE_URL}/v1/symptoms?q=${text}&limit=5`;
export const GET_MATCHING_DRUGS = (text: string): string =>
    `${MEDICAL_DB_BASE_URL}/v1/drugs?q=${text}&limit=5`;
export const GET_DRUG_SEARCH = (from: string): string =>
    `${MEDICAL_DB_BASE_URL}/v1/drugs/search?from=${from}`;

export const MESSAGE_PUSH_CONFIG = (docid: string): string =>
    `${DOCS_APP_BE_URL}/config/set/${docid}`;
export const MESSAGE_GET_CONFIG = (docid: string): string =>
    `${DOCS_APP_BE_URL}/config/get/${docid}`;

export const PUSH_RENDER_PDF_TEMPLATE_IMAGE = (forNewDrugs?: boolean): string =>
    `${DOCS_APP_BE_URL}/service/template/assets/upload${forNewDrugs ? '?forNewDrugs=true' : ''}`;
export const PUSH_ATTACHMENT = `${DOCS_APP_BE_URL}/service/attachment/upload`;
export const SEND_ATTACHMENTS = `${DOCS_APP_BE_URL}/post/attachments/upload`;
export const PUSH_RENDER_PDF_TEMPLATE_CONFIG = (docid: string): string =>
    `${DOCS_APP_BE_URL}/service/template/create?docid=${docid}`;
export const PATIENT_AVATAR_UPLOAD = (pid: string): string =>
    `${DOCS_APP_BE_URL}/service/patient/assets/upload?patientid=${pid}`;
export const DELETE_TEMPLATE_CONFIG = `${DOCS_APP_BE_URL}/service/template/delete`;

export const v2rxDataOnCopyForBQ = `${DOCS_APP_BE_URL}/app/patient-data-oncopy`;
export const GET_MATCHING_DIAGNOSES = (text: string, limit: number = 5, qParams?: string): string =>
    `${MEDICAL_DB_BASE_URL}/v1/diagnoses?q=${text}&limit=${limit}&${qParams}`;
export const GET_MATCHING_PROCEDURES = (text: string, spec?: string): string =>
    `${MEDICAL_DB_BASE_URL}/v1/procedures?q=${text}&limit=8${spec ? `&spec=${spec}` : ''}`;
export const GET_MATCHING_ALLERGIES = (text: string): string =>
    `${MEDICAL_DB_BASE_URL}/v1/allergies?q=${text}&limit=5`;

export const TELE_CALLURL = (apptId: string): string =>
    `${FINGERTIP}/app/visit/start-call/${apptId}`;

export const GET_MATCHING_SYM_DIA = (
    text: string,
    gender?: 'M' | 'F' | 'O',
    spec?: string,
): string =>
    `${MEDICAL_DB_BASE_URL}/v1/sym-and-diag?q=${text}&limit=8${gender ? `&gender=${gender}` : ''}${
        spec ? `&spec=${spec}` : ''
    }`;
export const GET_MATCHING_LAB_VITALS = (text: string): string =>
    `${MEDICAL_DB_BASE_URL}/v1/inv-readings?q=${text}&limit=8`;

export const GET_SYM_DIA_FROM_SYM_DIA = (
    symIds: string,
    diaIds: string,
    gender?: 'M' | 'F' | 'O',
): string =>
    `${MEDICAL_DB_BASE_URL}/v1/sym-and-diag/related?symptoms=${symIds}&diagnoses=${diaIds}&limit=8${
        gender ? `&gender=${gender}` : ''
    }`;
export const GET_SYM_DIA_PROPERTIES = (symIds: string, diaIds: string): string =>
    `${MEDICAL_DB_BASE_URL}/v1/sym-and-diag/properties?symptoms=${symIds}&diagnoses=${diaIds}`;

export const GET_MATCHING_GENERICS = (text: string): string =>
    `${MEDICAL_DB_BASE_URL}/v1/generic-composition?q=${text}&limit=10`;

export const GET_MATCHING_MANUFACTURER = (text: string): string =>
    `${MEDICAL_DB_BASE_URL}/v1/mfr?q=${text}&limit=10`;

export const GET_DRUGS_BY_IDS = `${MEDICAL_DB_BASE_URL}/v1/drug-details`;

export const GET_MATCHING_DRUGS_LAB_TESTS = (
    text: string,
    hem: boolean = false,
    hel: boolean = false,
    cat: string,
    generic_id: string = '',
    show_custom: boolean = true,
    cid?: string,
    s_type?: S_TYPE | '',
    is_injection?: boolean,
): string => {
    const url = new URL(`${MEDICAL_DB_BASE_URL}/v1/drugs-and-labs`);
    if (text) {
        url.searchParams.set('q', text);
    }
    if (hem) {
        url.searchParams.set('hem', hem.toString());
    }
    url.searchParams.set('limit', '8');
    if (hel) {
        url.searchParams.set('hem', hel.toString());
        url.searchParams.set('limit', '16');
    }
    if (hel) {
        url.searchParams.set('hem', hel.toString());
    }
    if (generic_id) {
        url.searchParams.set('generic_id', generic_id.toString());
    }
    if (show_custom) {
        url.searchParams.set('show_custom', show_custom.toString());
    }
    if (cid) {
        url.searchParams.set('cid', cid.toString());
    }
    if (s_type) {
        url.searchParams.set('s_type', s_type.toString());
    }
    if (is_injection) {
        url.searchParams.set('is_injection', is_injection.toString());
    }
    if (cat) {
        url.searchParams.set('cat', cat);
    }

    return url.toString();
};
export const GET_MATCHING_LAB_TESTS = (text: string, gender?: 'M' | 'F' | 'O'): string =>
    `${MEDICAL_DB_BASE_URL}/v1/lab-tests?q=${text}&limit=8${
        gender ? `&gender=${gender}` : ''
    }&type=fill_vitals`;

export const GET_DRUGS_INTERACTIONS = `${MEDICAL_DB_BASE_URL}/v2/drugs/interaction`;
export const GET_COMPLIMENTARY_DRUGS = (ids: string): string =>
    `${MEDICAL_DB_BASE_URL}/v1/drugs/complimentary?drugs=${ids}`;

export const GET_DRUGS_LAB_TESTS_FROM_SYM_DIA = (symIds: string, diaIds: string): string =>
    `${MEDICAL_DB_BASE_URL}/v1/sym-and-diag/drugs-and-labs?symptoms=${symIds}&diagnoses=${diaIds}&limit=10`;

export const GET_DRUGS_LAB_TESTS_HXNG_STATUS = `${MEDICAL_DB_BASE_URL}/v1/get-hxng-status`;

export const VERIFY_MOBILE_NUMBER = `${AUTH_BASE_URL}/auth/init`;
export const INIT_LOGIN = (version: 'v1' | 'v2'): string =>
    `${AUTHGO_BASE_URL}/emr/${version}/auth/init`;
export const VERIFY_LOGIN = (version: 'v1' | 'v2'): string =>
    `${AUTHGO_BASE_URL}/emr/${version}/auth/verify`;
export const VERIFY_OTP = `${AUTH_BASE_URL}/auth/verify`;
export const FIREBASE_TOKEN = `${COG}/firebase`;
export const RESEND_OTP = (version: 'v1' | 'v2'): string =>
    `${AUTHGO_BASE_URL}/emr/${version}/auth/resend`;
export const GET_BULK_PATIENTS = (pids: string): string =>
    `${AUTHGO_BASE_URL}/profiles/v1/business-patient/bulk?oid_list=${pids}`;

export const AORTA_CREATE_PATIENT = `${AUTHGO_BASE_URL}/profiles/v1/patient/`;
export const AORTA_UPDATE_PATIENT = (oid: string): string =>
    `${AUTHGO_BASE_URL}/profiles/v1/patient/${oid}`;
export const AORTA_GET_PATIENT = (oid: string): string =>
    `${AUTHGO_BASE_URL}/profiles/v1/patient/${oid}?arc=true`;
export const AORTA_ARCHIVE_PATIENT = (oid: string): string =>
    `${AUTHGO_BASE_URL}/profiles/v1/patient/${oid}`;

export const TOKEN_REFRESH = `${AUTH_BASE_URL}/auth/refresh`;
export const TOKEN_REFRESH_V2 = `${AUTHGO_BASE_URL}/emr/v3/auth/refresh`;
export const LOGOUT = `${AUTHGO_BASE_URL}/v3/auth/logout`;
export const GET_DOC_PROFILES = `${AUTH_BASE_URL}/doc/profiles`;
export const GET_DOC_ACCOUNTS = `${AUTH_BASE_URL}/doc/profiles?byUuid=1&byScope=0`;
export const GET_MY_PROFILES = `${APPOINTMENTS_BE_URL}/access-control/v2/get-users-for-uuid`;
export const SWITCH_DOCTOR = `${AUTH_BASE_URL}/doctor/switch`;
export const GET_ALL_STAFF = `${AUTH_BASE_URL}/staff?filter=0`;
export const USE_ABHA = (
    docid: string,
    clinic_id: string,
    redirection_url: string,
    doctor_name: string,
    patient_id?: string,
    mobile_number?: string,
    subflow?: string,
): string =>
    `${ABHA}/ayushman-bharat/minis/create-abha-abdm-ndhm-health-id?flow=hmis${
        clinic_id ? `&clinic-id=${clinic_id}` : ''
    }${docid ? `&doc-id=${docid}` : ''}${redirection_url ? `&redirectTo=${redirection_url}` : ''}${
        patient_id ? `&patient-id=${patient_id}` : ''
    }${doctor_name ? `&doctorname=${doctor_name}` : ''}${
        mobile_number ? `&mobile=${mobile_number}` : ''
    }${subflow ? `&subflow=${subflow}` : ''}`;
export const PUSH_VISIT = (force: boolean, ignoredraft: boolean, draftid: string): string =>
    `${DOCS_APP_BE_URL}/app/savevisit/?force=${force}&ignoredraft=${ignoredraft}&draftid=${draftid}`;
export const GET_TRIAL_ORDER_PRESCRIPTION = (docid: string) =>
    `${DOCS_APP_BE_URL}/app/get-trial-order-prescription/${docid}`;
export const SEND_REVIEW_LINK = (aid: string) =>
    `${APPOINTMENTS_BE_URL}/business/appointment/${aid}/request-review`;
export const PREIVEW_VISIT = (force: boolean): string =>
    `${DOCS_APP_BE_URL}/pdf/render/preview/?force=${force}`;
export const PREIVEW_VISIT_V2 = (force: boolean): string =>
    `${DOCS_APP_BE_URL}/pdf/render/V2/preview/?force=${force}`;
export const LAB_VITAL_INTERPRETATION = `${DOCS_APP_BE_URL}/service/lab-vital/interpretation`;
export const PUSH_PATIENT = (docId?: string): string =>
    `${DOCS_APP_BE_URL}/app/add/patientdirectory/${docId ?? ''}`;
export const YEAR_END_REVIEW = (docId: string): string =>
    `${LITTMANN}/app/direct/year-end-review/${docId}`;
export const TRIGGER_VISIT_SMS = (visitId: string, ph?: string): string =>
    `${DOCS_APP_BE_URL}/service/sendvisitsms/${visitId}${ph ? `/?phone=${ph}` : ''}`;
export const TRIGGER_VISIT_MESSAGE = `${DOCS_APP_BE_URL}/service/sendvisitmessage`;
export const PUSH_GENIE = (docid: string): string =>
    `${DOCS_APP_BE_URL}/app/create/genieprofile/${docid}`;
export const GET_BOOK_SLOT_HASH = (id: string, docid?: string): string =>
    `${DOCS_APP_BE_URL}/service/slot/book/${id}${docid ? `?docid=${docid}` : ''}`;
export const GET_DOC_PROFILE = (docId?: string): string =>
    `${DOCS_APP_BE_URL}/profile/get/doctorprofile${docId ? `/${docId}` : ''}`;
export const GET_MY_PROFILE = (groupId?: string): string =>
    `${DOCS_APP_BE_URL}/profile/get${groupId ? `?group_id=${groupId}` : ''}`;
export const GET_PRESCRIPTION_TEMPLATE = '/prescriptionTemplateData.json';
export const TRIGGER_INVOICE = (
    vId: string,
    notifyOnly: boolean,
    readOnly: boolean,
    withHeader: boolean,
): string =>
    `${DOCS_APP_BE_URL}/service/invoice/v2/generate/${vId}${
        notifyOnly || readOnly || !withHeader
            ? `?notifyOnly=${notifyOnly}&viewOnly=${readOnly}&withheader=${withHeader}`
            : ''
    }`;
export const LIST_INVOICE = (vId: string): string =>
    `${DOCS_APP_BE_URL}/service/invoice/byappointmentid/${vId}`;
export const GET_DOC_GENIE_BY_OID = (
    docOId: string,
    from?: string,
    treatmentServicesAndTreatmentPackagesEnabled?: boolean,
): string =>
    `${DOCS_APP_BE_URL}/app/get/genieprofile/${docOId}?${from ? `from=${from}` : ''}${
        treatmentServicesAndTreatmentPackagesEnabled
            ? `&treatmentServicesAndTreatmentPackages=true`
            : ''
    }`;
export const GET_MY_GENIE = (
    docids?: string[],
    from?: string,
    treatmentServicesAndTreatmentPackagesEnabled?: boolean,
    roles?: string[],
): string => {
    return `${DOCS_APP_BE_URL}/app/get/my/genieprofile?${buildQueryParams({
        docids: docids?.join(','),
        from,
    })}${
        treatmentServicesAndTreatmentPackagesEnabled
            ? `&treatmentServicesAndTreatmentPackages=true`
            : ''
    }${roles ? `&roles=${roles.join(',')}` : ''}`;
};
export const INIT_VISIT = (docOId: string): string => `${DOCS_APP_BE_URL}/app/initvisit/${docOId}`;
export const PATIENT_DIR = (docOIds: string[], pid?: string, from?: string): string =>
    `${DOCS_APP_BE_URL}/app/get/my/patients?docids=${docOIds.join(',')}${
        pid ? `&pid=${pid}` : from ? `&from=${from}` : ''
    }`;
export const PATIENT_DIR_V2 = (docOIds: string[], from?: string): string =>
    `${DOCS_APP_BE_URL}/app/my/V2/patients?docids=${docOIds.join(',')}${
        from ? `&from=${from}` : ''
    }`;

export const PATIENT_DIR_TRINITY = (
    docOIds: string[],
    pid?: string,
    from?: string,
    pageNo?: string,
    pageSize?: string,
): string =>
    `${DOCS_APP_BE_URL}/app/get/my/patients?docids=${docOIds.join(',')}${pid ? `&pid=${pid}` : ''}${
        from ? `&from=${from}` : ''
    }${pageNo ? `&pageNo=${pageNo}` : ''}${pageSize ? `&pageSize=${pageSize}` : ''}`;

export const GET_PRESCRIPTION_BY_ID = (pxId: string): string =>
    `${DOCS_APP_BE_URL}/app/getprescription/${pxId}`;
export const VIEW_PDF = (pxId: string): string => `${DOCS_APP_BE_URL}/pdf/view/${pxId}`;
export const GET_PT_MED_HISTORY = (docId: string, ptId: string): string =>
    `${DOCS_APP_BE_URL}/app/get/patientmedicalhistory/?docid=${docId}&pid=${ptId}`;
export const PUSH_PT_MED_HISTORY = (docId: string, ptId: string): string =>
    `${DOCS_APP_BE_URL}/app/create/patientmedicalhistory/${ptId}/?docid=${docId}`;
export const PUSH_PT_VACCINATION_HISTORY = (docId: string, ptId: string): string =>
    `${DOCS_APP_BE_URL}/app/update/vaccination-history/${ptId}/?docid=${docId}`;
export const INIT_PAYMENT_REQUEST = `${DOCS_APP_BE_URL}/service/payment/init`;
export const GET_PAST_VITALS = (pid: string): string => `${DOCS_APP_BE_URL}/app/get/vitals/${pid}`;
export const GET_ASSESSMENT_SUMMARY = (vId: string): string =>
    `${DOCS_APP_BE_URL}/app/get/sa-v2/${vId}`;
export const GET_PAST_ASSESSMENT_SUMMARY = (saId: string): string =>
    `${DOCS_APP_BE_URL}/app/get/sa-v2/?sa=${saId}`;
export const GET_BATCH_ASSESSMENT_SUMMARY = (saIds: string): string =>
    `${DOCS_APP_BE_URL}/app/get/batch-sa/?sa_ids=${saIds}`;
export const GET_ALL_TRANSACTIONS = `${DOCS_APP_BE_URL}/service/payment/get/transactions`;
export const GET_ANALYTICS = (qId: string): string => `${DOCS_APP_BE_URL}/analytics/query/${qId}/`;
export const GET_SPECIALITY_FOR_DOCTOR = `${DOCS_APP_BE_URL}/app/get/speciality-for-doctor`;
export const CREATE_REFERAL = `${DOCS_APP_BE_URL}/app/create/referral/`;
export const GET_RECEIPTS_BY_PATIENT = (ptId: string): string =>
    `${APPOINTMENTS_BE_URL}/business/receipts/patient/${ptId}`;
export const SEND_RECEIPTS_TO_PATIENT_VIA_WA = (docId: string, receiptId: number): string =>
    `${APPOINTMENTS_BE_URL}/receipt/${docId}/${receiptId}/send-to-wa`;
export const GET_MEDICAL_CERTIFICATES_BY_PATIENT = (ptId: string): string =>
    `${DOCS_APP_BE_URL}/service/mcert/${ptId}`;
export const GET_TODAY_QUEUE = (cid: string, startTime: string, endTime: string): string =>
    `${DOCS_APP_BE_URL}/apt/get/today/queue/${cid}?starttime=${startTime}&endtime=${endTime}&pt=false`;
export const GET_COMPLETED_APPOINTMENTS_ALL_TIME = (cid: string): string =>
    `${DOCS_APP_BE_URL}/apt/get/completed/queue/${cid}`;
export const GET_UPCOMING_APPOINTMENTS_ALL_TIME = (cid: string): string =>
    `${DOCS_APP_BE_URL}/apt/get/upcoming/queue/${cid}`;
export const GET_APPOINTMENTS_V3 = (cid: string, start: string, end: string): string =>
    `${APPOINTMENTS_BE_URL}/business/clinic/${cid}/appointments/${start}/${end}`;
export const GET_OTHER_APPOINTMENTS_ALL_TIME = (cid: string): string =>
    `${DOCS_APP_BE_URL}/apt/get/other/queue/${cid}`;
export const GET_PX_DRAFT = (
    visitId: string,
    ptId?: string,
    fetchOngoingTreatmentPlans?: boolean,
): string =>
    `${DOCS_APP_BE_URL}/app/prepare-px/${visitId}?${ptId ? `ptid=${ptId}` : ''}${
        fetchOngoingTreatmentPlans ? `&ongoingTreatmentPlans=true` : ''
    }`;
export const GET_PT_SA = (plId: string): string =>
    `${DOCS_APP_BE_URL}/app/get/sa-by-patient/${plId}`;
export const PUSH_PX_DRAFT = (): string => `${DOCS_APP_BE_URL}/app/push/px-draft/`;
export const GET_GMB_TOKEN = (): string => `${DOCS_APP_BE_URL}/gmb/get-token/`;
export const UHID_PUSH_CONFIG = (): string => `${DOCS_APP_BE_URL}/app/uhid/push-config`;
export const UHID_GET_CONFIG = (): string => `${DOCS_APP_BE_URL}/app/uhid/get-config`;
export const UHID_SUGGEST = (): string => `${DOCS_APP_BE_URL}/app/uhid/suggest`;
export const MY_QR = (docid: string): string => `${DOCS_APP_BE_URL}/service/doctor-qr/${docid}`;
export const ABHA_QR = (clinicId: string): string =>
    `${DOCS_APP_BE_URL}/service/abha-qr/?clinicId=${clinicId}`;
export const UPDATE_ADD_PT_DY_FORM = `${DOCS_APP_BE_URL}/app/create/form`;
export const INIT_TEMPLATE_BUILDER = `${DOCS_APP_BE_URL}/pdf/template/builder/init`;
export const PREVIEW_TEMPLATE_BUILDER = `${DOC_TOOL}/pdf/template/builder/preview`;
export const SAVE_TEMPLATE_BUILDER = `${DOCS_APP_BE_URL}/pdf/template/builder/save`;
export const RESET_TEMPLATE_BUILDER = `${DOCS_APP_BE_URL}/pdf/template/builder/reset`;
export const PUSH_M_CERT = (docid: string) => `${DOCS_APP_BE_URL}/service/mcert/save/${docid}`;
export const PUSH_FORM = (docid: string) => `${DOCS_APP_BE_URL}/service/consent-form/save/${docid}`;
export const REQUEST_VITALS = `${DOCS_APP_BE_URL}/service/request/pt-vitals`;
export const GET_ALL_VISITS = (plId: string, limit: number = 0): string =>
    `${DOCS_APP_BE_URL}/app/get-all-pad-visit/${plId}${
        Number(limit) > 0 ? `?limit=${Number(limit)}` : ''
    }`;

export const NHDM_CONSENT_LIST = `${NDHM_URL}/v1/consent/list`;
export const NHDM_CREATE_CONSENT = `${NDHM_URL}/v1/consent/create`;
export const NHDM_VAULT_DOCS = `${NDHM_URL}/v1/consent/get-vault-docs`;

export const PARCHI_GEN_OTP = `${DOCS_APP_BE_URL}/service/abha/send-otp`;
export const PARCHI_REQUEST_ABHA = (ptId: string): string =>
    `${DOCS_APP_BE_URL}/service/request/abha/create/${ptId}`;
export const NHDM_CONFIRM_OTP = `${NDHM_URL}/v2/hmis/registration/mobile/confirm-otp`;
export const NHDM_RESEND_OTP = `${NDHM_URL}/v2/hmis/registration/mobile/resend-otp`;
export const NHDM_LOGIN = `${NDHM_URL}/v2/hmis/registration/mobile/login`;
export const NHDM_ABHA_CREATE = `${NDHM_URL}/v2/hmis/registration/mobile/create`;

export const M_CERT_TEMPLATES = (docid: string): string =>
    `${DOCS_APP_BE_URL}/service/mcert/templates/${docid}`;
export const TRANSLATE_ADVICES = `${DOCS_APP_BE_URL}/service/translate/advices`;
export const SEND_TO_SLACK = `${DOCS_APP_BE_URL}/service/notify/slack`;
export const GET_PROFILES_BY_MOBILE = (
    mobile: string,
    cid?: string,
    enableNdhmDiscovery?: boolean,
): string =>
    `${DOCS_APP_BE_URL}/profile/get-by-mobile?mobile=${mobile}&cid=${cid}${
        enableNdhmDiscovery ? '&abha=true' : ''
    }`;

export const GET_APPOINTMENTS = (docId: string, date: string, cid?: string): string =>
    `${APPOINTMENTS_BE_URL}/doctor/appointment/${docId}?date=${date}&cid=${cid}`;
export const GET_COMPLETED_APPOINTMENTS = (docId: string, date: string, cid?: string): string =>
    `${APPOINTMENTS_BE_URL}/doctor/appointment/completed/${docId}?date=${date}&cid=${cid}&pageSize=500&page=0`;
export const SEND_START_VISIT_EVENT = (visitId: string): string =>
    `${APPOINTMENTS_BE_URL}/appointment/${visitId}/start-visit`;
export const GET_DASHBOARD_ANALYTICS = (docId: string): string =>
    `${APPOINTMENTS_BE_URL}/doctor/analytics/${docId}`;
export const DOCTOR_PROFILE = (username?: string): string =>
    `${BOOKING_SLUG}/doctor/${username}/profile`;
export const END_APPOINTMENT = (visitId: string): string =>
    `${APPOINTMENTS_BE_URL}/appointment/${visitId}/end-visit`;
export const SEND_SELF_ASSESSMENT_LINK = (aid: string): string =>
    `${APPOINTMENTS_BE_URL}/appointment/${aid}/send-message`;
export const GET_APPOINTMENT_BY_ID = (aid: string): string =>
    `${APPOINTMENTS_BE_URL}/appointment/${aid}`;
export const GET_APPOINTMENT_VC_META_BY_AID = (aid: string): string =>
    `${APPOINTMENTS_BE_URL}/appointment/${aid}/vc_meta`;
export const BOOK_APPOINTMENT = (docId: string, cId: string): string =>
    `${APPOINTMENTS_BE_URL}/book-slot/${docId}/${cId}`;
export const BOOK_BUSINESS_APPOINTMENT = (docId: string): string =>
    `${APPOINTMENTS_BE_URL}/business/v3/book-slot/${docId}`;

export const SEND_KHATA_INVOICE = `${DOCS_APP_BE_URL}/service/generate-invoice/khata`;

export const GO_TO_SYNC_DASHBOARD = `${SYNC_BE_URL}/dashboard`;

export const INIT_VIDEO_CALL = `${TELE_BE_URL}/v1/start/`;
export const GET_VIDEO_RECORDING_URL = (visitId: string): string =>
    `${TELE_BE_URL}/v1/getrecording/?appointmentid=${visitId}`;

export const GET_MEDICAL_RECORDS = (
    pId: string,
    search_term?: string,
    withRefresh?: boolean,
    limit?: boolean,
): string =>
    `${MEDICAL_RECORDS_BE_URL}/api/v1/docs?oid=${pId}${
        search_term ? `&q=${search_term}` : ''
    }&sort=ut${withRefresh ? '&refresh=true' : ''}${limit ? '&limit=1' : ''}`;
export const ADD_MEDICAL_RECORDS_NOTES = (pId: string, document_id: string): string =>
    `${MEDICAL_RECORDS_BE_URL}/api/v3/docs/${encodeURIComponent(document_id)}/notes?oid=${pId}`;

export const DESCRIBE_MEDICAL_RECORDS_NOTES_WITH_PAGINATION = (
    pId: string,
    document_id: string,
    next_token?: string,
): string =>
    `${MEDICAL_RECORDS_BE_URL}/api/v3/docs/${encodeURIComponent(document_id)}/notes?oid=${pId}${
        next_token ? `&next_token=${next_token}` : ''
    }`;

export const GET_ALL_MEDICAL_FILES_IN_A_DOCUMENT = (
    pId: string,
    docId: string,
    vitalId?: string,
): string =>
    `${MEDICAL_RECORDS_BE_URL}/api/v1/docs/${encodeURIComponent(docId)}?oid=${pId}${
        vitalId ? `&eka_id=${vitalId}` : ''
    }`;
export const INITIATE_FILE_UPLOAD = `${MEDICAL_RECORDS_BE_URL}/api/v3/docs`;
export const DELETE_MEDICAL_RECORD = (docId: string, plId: string): string =>
    `${MEDICAL_RECORDS_BE_URL}/api/v1/docs/${encodeURIComponent(docId)}/?oid=${plId}`;

export const MARK_PAYMENTS_AS_PAID = `${PAYMENTS}/mark_as_paid/`;
export const STORAGE_INFO = `${MEDICAL_RECORDS_BE_URL}/api/v1/usage`;

export const ANALYTICS_TOP_COUNT = `${ANALYTICS}/v1/fhir/doctor_analytics/topCount/`;
export const ANALYTICS_ITEMS_COUNT = `${ANALYTICS}/v1/fhir/doctor_analytics/itemsCount/`;
export const ANALYTICS_PATIENTS_LIST = `${ANALYTICS}/v1/fhir/doctor_analytics/itemsPatientData/`;
export const FETCH_APPT_CONFIGS = (docId: string): string =>
    `${APPOINTMENTS_BE_URL}/queue-config/${docId}`;
export const GET_DOCTOR_SCHEDULE = (docId: string): string =>
    `${APPOINTMENTS_BE_URL}/docal/schedule/${docId}`;
export const RESCHEDULE_APPOINTMENT = (): string =>
    `${APPOINTMENTS_BE_URL}/v3/reschedule-appointment`;
export const CANCEL_APPOINTMENT = (aid: string): string =>
    `${APPOINTMENTS_BE_URL}/business/appointment/${aid}/cancel`;
export const CHECK_IN_APPOINTMENT = (aid: string): string =>
    `${APPOINTMENTS_BE_URL}/business/appointment/${aid}/check-in`;

export const USER_PREFERENCE = `${APPOINTMENTS_BE_URL}/queue-config/user-preference`;

const MAPS_API_KEY = 'AIzaSyCvbFk7mqA_5GmebRdY0AhXfX1HQrwKQo4';

export const GET_LATLNG_FROM_PINCODE = (pincode: string): string =>
    `https://maps.googleapis.com/maps/api/geocode/json?address=${pincode}&key=${MAPS_API_KEY}`;

export const UPDATE_PT_ID_IN_APPOINTMENT = (aid: string): string =>
    `${APPOINTMENTS_BE_URL}/appointment/${aid}/patient`;
export const DOCTOR_PAYMENT_SUMMARY = (startDate: string, endDate: string): string =>
    `${APPOINTMENTS_BE_URL}/doctor/payments-summary?start_date=${encodeURIComponent(
        startDate,
    )}&end_date=${encodeURIComponent(endDate)}`;

export const GET_SNACKING_QUESTIONS = (version: string): string =>
    `${DOCS_APP_BE_URL}/service/snacking/get-questions?version=${version}`;
export const ANSWER_SNACKING_QUESTION = `${DOCS_APP_BE_URL}/service/snacking/answer-question`;

export const HE_ONBOARDING_PROFILE = `${DOCS_APP_BE_URL}/profile/he-onboarding-profile`;
export const ADD_BANK_ACCOUNT_PARCHI = `${DOCS_APP_BE_URL}/profile/add-bank-account`;

export const HEALTH_WEEK_PACKAGES = `${DOCS_APP_BE_URL}/service/health-week-packages`;
export const HEALTH_WEEK_CONSENT = `${DOCS_APP_BE_URL}/service/health-week-consent`;

export const PARTNER_CONSENT = `${DOCS_APP_BE_URL}/service/partner-consent`;

export const GET_BANK_ACCOUNT_POCKET = (isForDoctor?: boolean): string =>
    `${POCKET_URL}/payment/get-bank-account${isForDoctor ? '?is_for_doctor=true' : ''}`;
export const GET_VALIDATION_STATUS_POCKET = `${POCKET_URL}/payment/get-validation-status`;
export const MARK_BANK_ACCOUNT_VALIDATED_POCKET = `${POCKET_URL}/payment/mark-bank-account-validated`;
export const GET_PAYOUTS = (isForDoctor?: boolean): string =>
    `${POCKET_URL}/payment/get-payouts${isForDoctor ? '?is_for_doctor=true' : ''}`;
export const GET_PAYOUTS_REPORT = (month: string, year: string, isForDoctor?: boolean): string =>
    `${POCKET_URL}/payment/get-payouts-report?month=${month}&year=${year}${
        isForDoctor ? '&is_for_doctor=true' : ''
    }`;

export const GET_HXNG_CONSENT = (pxId: string): string =>
    `${DOCS_APP_BE_URL}/service/hxng-consent/${pxId}`;
export const SET_HXNG_CONSENT = `${DOCS_APP_BE_URL}/service/hxng-consent`;

export const GOOGLE_REVIEW_SEARCH_SELECT = (docid: string): string =>
    `${ELIXIR_URL}/gmb-review-link/search-and-select?docid=${docid}`;

export const FETCH_DRUGS_SUBSTITUTE = (docid: string): string =>
    `${POCKET_URL}/app/get/drugs-substitute/${docid}`;

export const GET_BALANCE = `${KHATA}/balance`;
export const GET_REFERRAL_GIVEN_DATA_BY_DOC_ID = `${DOCS_APP_BE_URL}/service/get-patient-referral-data`;
export const GET_MY_BUSINESS_DOCTORS = `${DOCS_APP_BE_URL}/service/business/doctors`;

export const GET_LEDGER = (start_date: string, end_date: string): string =>
    `${KHATA}/ledger?start_date=${start_date}&end_date=${end_date}`;

export const GET_ABHA_METRICS_DASHBOARD = (docid: string, cid: string): string =>
    `${DOCS_APP_BE_URL}/service/get-abha-metrics-dashboard?docid=${docid}&cid=${cid}`;
export const GET_DOCTOR_AUTO_SUGGEST = (searchString: string): string =>
    `${AXON_URL}/autosuggest/doctor?q=${searchString}`;
export const GET_REFERRAL_RECEIVED_BY_DOC_ID = `${DOCS_APP_BE_URL}/app/get-referral-received-data`;
export const DOCTOR_REFERRAL_THANK_YOU = `${DOCS_APP_BE_URL}/service/doctor-referral-thanks-you`;
export const UPDATE_ABHA_INCENTIVE_STATUS = `${DOCS_APP_BE_URL}/service/abha-incentive/status/update`;

export const GET_ALL_ORDERS = (docIds: string, patientId: string): string =>
    `${DOCS_APP_BE_URL}/service/all-orders/${patientId}${docIds ? `?docids=${docIds}` : ''}`;

export const GET_ACTIVE_ORDERS = (
    docIds: string = '',
    active_from: number = 0,
    from: string = '',
    to: string = '',
): string =>
    `${POCKET_URL}/app/get-active-orders?${active_from ? `active_from=${active_from}` : ''}${
        from && to ? `&from=${from}&to=${to}` : ''
    }${docIds ? `&docids=${docIds}` : ''}`;

export const GET_PATIENT_HEALTH_SUMMARY = (patientId: string): string =>
    `${DOCS_APP_BE_URL}/service/health-summary/${patientId}`;

export const RESCHEDULE_LAB_TEST_SLOT = (docid: string) =>
    `${POCKET_URL}/lab/slot/reschedule/${docid}`;

export const GET_MILESTONES = (lastUpdated?: string, version?: string) =>
    `${DOCS_APP_BE_URL}/service/get/milestones${lastUpdated ? `?from=${lastUpdated}` : ''}${
        version ? `&version=${version}` : ''
    }`;

export const ADD_MILESTONE = `${DOCS_APP_BE_URL}/service/add/milestone`;
export const DELETE_MILESTONE = `${DOCS_APP_BE_URL}/service/delete/milestone`;
export const GET_DOC_ASSIST_HASH = `${LUCID}/doc_chat/v1/get_doctor_hash`;
export const PREDICT_NEXT_MEDICINES = `${LUCID}/copilot/v1/predict_next_medicines`;

export const PATIENT_HEALTH_SUMMARY_WITH_POOLING = (
    patientId: string,
    information_hash?: string,
): string =>
    `${LUCID}/doc/v2/poll_generate_summary?pt_oid=${patientId}${
        information_hash ? `&information_hash=${information_hash}` : ''
    }`;

export const FETCH_ALL_DOCTOR_DETAILS_BY_IDS = `${DOCS_APP_BE_URL}/service/doctor-profile-by-ids`;

export const ARCHIVE_PATIENT = (ptId: string): string =>
    `${DOCS_APP_BE_URL}/app/archive-patient/${ptId}`;

export const GET_DOCTOR_ANALYTICS_GUEST_TOKEN = (type: string) =>
    `${TELE_BE_URL}/v1/doctor_analytics_guest_token?type=${type}`;

export const GET_SUPPORT_TICKETS = `${DOCS_APP_BE_URL}/service/support-tickets`;
export const GET_SUPPORT_TICKET_ACTIONS = (id: string): string =>
    `${DOCS_APP_BE_URL}/service/support-ticket/${id}/actions`;

export const POST_AI_ASSIST_NEW_MESSAGE = (
    connectId: string,
    patientData: boolean,
    ptId: string,
    docId: string,
    hash: string,
    suggestion_clicked?: boolean,
) =>
    `${LUCID_WS}/doc_chat/v1/stream_chat?session_id=${connectId}&use_patient_data=${patientData}&pt_oid=${ptId}&d_oid=${docId}&d_hash=${hash}${
        suggestion_clicked ? `&suggestion_clicked=${suggestion_clicked}` : ''
    }`;

export const LUCID_RUN_PROMPT = `${RUN_PROMPT}/prompt_runner/v1/run_prompt_stream`;

export const GET_GENERATE_QUESTIONS = (session_id: string, pt_oid: string) =>
    `${LUCID}/doc_chat/v1/generate_questions?session_id=${session_id}&pt_oid=${pt_oid}`;

export const CREATE_TREATMENT_PACKAGE = `${DOCS_APP_BE_URL}/service/treatment-package`;

export const GET_TREATMENT_PLANS = (patientId: string, type?: TREATMENT_PLAN_TYPE) =>
    `${DOCS_APP_BE_URL}/service/treatment-plans/${patientId}${type ? `?type=${type}` : ''}`;

export const GET_TREATMENT_PLAN = (planId: string, aId: string) =>
    `${DOCS_APP_BE_URL}/service/treatment-plan/${planId}${aId ? `?aid=${aId}` : ''}`;

export const CREATE_TREATMENT_PLAN = `${DOCS_APP_BE_URL}/service/treatment-plan`;
export const GET_DOC_ASSIST_WORD_SUMMARY = (
    text: string,
    hash: string,
    ptId: string,
    modelId: string,
): string =>
    `${LUCID}/doc/v2/specific_diagnosis_text?information_hash=${hash}&pt_oid=${ptId}&model_id=${encodeURIComponent(
        modelId,
    )}&condition_span_text=${encodeURIComponent(text)}`;

export const ABHA_CONSENT_URL = (ptId: string, health_id?: string, clinicId?: string): string =>
    `${HUB}/abdm/medical_records/${ptId}/?health_id=${health_id}&clinic_id=${clinicId}`;

export const GET_MR_PARAMETERS = (vitalId: string, plId: string): string =>
    `${MEDICAL_RECORDS_BE_URL}/api/d/v1/parameters/${vitalId}?p_oid=${plId}`;

export const GET_DICOM_RECORDS = (uuid: string, next_token?: string) =>
    `${MEDICAL_RECORDS_BE_URL}/api/d/v1/dicom?p_uuid=${uuid}${
        next_token ? `&next_token=${next_token}` : ''
    }`;

export const SET_DICOM_RECORD = (p_oid: string) =>
    `${MEDICAL_RECORDS_BE_URL}/api/d/v1/dicom?p_oid=${p_oid}`;

export const DELETE_DICOM_RECORD = (key: string) =>
    `${MEDICAL_RECORDS_BE_URL}/api/d/v1/dicom/${key}`;

export const IPD_ADMIT_PATIENT = `${REVIVE}/admissions`;
export const IPD_GENERATE_IPID = `${REVIVE}/admissions/generate-ipid`;
export const IPD_GET_ADMISSION_ADVICE = (pid: string): string =>
    `${REVIVE}/admissions/advices/${pid}`;
export const IPD_LOAD_DATA = (from?: string): string =>
    `${REVIVE}/ipd/${from ? `?from=${encodeURIComponent(from)}` : ''}`;
export const IPD_GET_BED_AVAILABILITY = `${REVIVE}/beds/availability`;

export const GET_IPD_ADMISSION_ESTIMATE = (aid: string): string =>
    `${REVIVE}/admissions/${aid}/estimate`;

export const IPD_ADMISSION_UPDATE = (aid: string): string => `${REVIVE}/admissions/${aid}`;

export const UPLOAD_CARE_CANVAS_IMAGE = `${DOCS_APP_BE_URL}/service/care-canvas/image-upload`;
export const GET_CARE_CANVAS_TEMPLATES = (docid: string) =>
    `${DOCS_APP_BE_URL}/service/care-canvas/templates/${docid}`;
export const UPLOAD_CARE_CANVAS_TEMPLATE = `${DOCS_APP_BE_URL}/service/care-canvas/template`;
export const CARE_CANVAS_TEMPLATE_BY_ID = (id: string) =>
    `${DOCS_APP_BE_URL}/service/care-canvas/template/${id}`;

export const POLL_MEDICAL_RECORDS = (pId: string, sourceRefreshedAt?: number): string =>
    `${MEDICAL_RECORDS_BE_URL}/api/v1/docs/refresh-status?oid=${pId}${
        sourceRefreshedAt ? `&source_refreshed_at=${sourceRefreshedAt}` : ''
    }`;

export const GET_TELE_LINKS_V2 = (aid: string) => {
    return `${TELE_BE_V2}/start-tele-process?aid=${aid}`;
};

export const GET_TELE_RECORDINGS_V2 = () => {
    return `${TELE_BE_V2}/get-recording`;
};

export const FETCH_PT_GLOBAL = (q: string, param: string) =>
    `${AUTHGO_BASE_URL}/profiles/v1/patient/search?${param}=${q}&limit=10`;
